export const shadow = {
  name: 'shadow',
  label: 'Box Shadow',
  component: 'radio-group',
  variant: 'button',
  direction: 'vertical',
  options: [
    {value: 'sm', label: 'Small'},
    {value: 'md', label: 'Normal'},
    {value: 'lg', label: 'Big'},
    {value: 'xl', label: 'Biggest'},
  ],
};
